export const navItems = [
    {
        id: '1',
        title: 'गृहपृष्ठ',
        path: '/',
        cName: 'nav-item',
    },
    {
        id: '2',
        title: 'हाम्रो बारेमा',
        path: '/aboutus',
        cName: 'nav-item',
    },
    {
        id: '3',
        title: 'मानविय श्रोत',
        path: '/hr',
        cName: 'nav-item',
    },
    {
        id: '4',
        title: 'हाम्रा सेवाहरु',
        path: '/services',
        cName: 'nav-item',
    },
    {
        id: '5',
        title: 'सामाजिक सेवा',
        path: '/socialservice',
        cName: 'nav-item',
    },
    {
        id: '6',
        title: 'सफलताका कथा',
        path: '/successstory',
        cName: 'nav-item',
    },
    {
        id: '7',
        title: 'प्रतिवेदन',
        path: '/report',
        cName: 'nav-item',
    },
    {
        id: '8',
        title: 'संस्थागत सम्मानहरु',
        path: '/award',
        cName: 'nav-item',
    },
    {
        id: '9',
        title: 'शेयर सदस्यताको लागि',
        path: '/membership',
        cName: 'nav-item',
    },
    {
        id: '10',
        title: 'क्यालेण्डर',
        path: '/calendar',
        cName: 'nav-item',
    },
    {
        id: '11',
        title: 'फोटो फिचर',
        path: '/gallery',
        cName: 'nav-item',
    },
];

export const aboutUsDropdown = [
    {
        id: '1',
        title: 'पृष्ठभुमी',
        path: '/aboutus/home',
        cName: 'link-item',
    },
    {
        id: '2',
        title: 'परिकल्पना',
        path: '/aboutus/parikalpana',
        cName: 'link-item',
    },
    {
        id: '3',
        title: 'ध्येय (लक्ष्य)',
        path: '/aboutus/dheya',
        cName: 'link-item',
    },
    {
        id: '4',
        title: 'उद्देश्य',
        path: '/aboutus/objectives',
        cName: 'link-item',
    },
    {
        id: '5',
        title: 'आबद्धता',
        path: '/aboutus/joining',
        cName: 'link-item',
    },
];

export const hrDropdown = [
    {
        id: '1',
        title: 'संचालक समिति',
        path: '/hr/bod-members',
        cName: 'link-item',
    },
    {
        id: '2',
        title: 'लेखा सुपरिवेक्षण समिति',
        path: '/hr/supervisory-committee',
        cName: 'link-item',
    },
    {
        id: '3',
        title: 'सल्लाहकार मण्डल',
        path: '/hr/advisory-board',
        cName: 'link-item',
    },
    {
        id: '4',
        title: 'पुर्व संचालक समिति',
        path: '/hr/FBODS',
        cName: 'link-item',
    },
    {
        id: '5',
        title: 'कर्मचारीहरू',
        path: '/hr/staffs',
        cName: 'link-item',
    },
    {
        id: '6',
        title: 'अन्य विभिन्न समितिहरू',
        path: '/hr/other-subcommittee',
        cName: 'link-item',
    },
];

export const servicesDropdown = [
    {
        id: '1',
        title: 'बचत सेवा',
        path: '/service/saving-service',
        cName: 'link-item',
    },
    {
        id: '2',
        title: 'ऋण सेवा',
        path: '/service/loan-service',
        cName: 'link-item',
    },
    {
        id: '3',
        title: 'अन्य सदस्य सेवा',
        path: '/service/other-member-sevice',
        cName: 'link-item',
    },
    {
        id: '4',
        title: 'सदस्य सम्मान कार्यक्रम',
        path: '/service/sadasya-samman-program',
        cName: 'link-item',
    },
    {
        id: '5',
        title: 'मोबाइल बैङकिङ सेवा',
        path: '/service/mobile-banking-service',
        cName: 'link-item',
    },
    {
        id: '6',
        title: 'सेवाकेन्द्रहरु',
        path: '/branches/all',
        cName: 'link-item',
    },
];

export const reportDropdown = [
    {
        id: '1',
        title: 'पर्ल्स प्रतिवेदन',
        path: '/report/PEARLS',
        cName: 'link-item',
    },
    {
        id: '2',
        title: 'मासिक प्रतिवेदन',
        path: '/report/monthly',
        cName: 'link-item',
    },
    {
        id: '3',
        title: 'वाषिर्क प्रतिवेदन',
        path: '/report/yearly',
        cName: 'link-item',
    },
];